module.exports = __webpack_public_path__ + "static/media/Base feature icon-1.5c1b2af8.svg";